import React from 'react';
import Nav from '../../Shared/Nav/Nav';
import OtherProjects from '../OtherProjects/OtherProjects';
import About from './About/About';
import Banner from './Banner/Banner';
import Experience from './Experience/Experience';
import Projects from './Projects/Projects';
import ProjectsSlider from './ProjectsSlider/ProjectsSlider';
import Skills from './Skills/Skills';

const Home = () => {
    return (
        <div>
            <Banner />
            <ProjectsSlider />
            <About />
            <Experience />
            <Skills />
            <Projects />
            <OtherProjects />
        </div>
    );
};

export default Home;